// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1okXC","error":"Textarea_error__2IigA","readonly":"Textarea_readonly__24Xcs","disabled":"Textarea_disabled__1TPF_"};